import { Box } from '@chakra-ui/react';

import { SummaryPopover, SummaryTrigger } from './SummaryPrimitives';

export type ModelVersionEntry = {
  modelLabel: string;
  versionLabel: string;
};

export const ModelVersionsSummary = ({
  entries,
  allLatest,
}: {
  entries: ModelVersionEntry[];
  allLatest: boolean;
}) => {
  const triggerText = allLatest ? 'Latest' : 'Custom';

  return (
    <SummaryPopover trigger={<SummaryTrigger text={triggerText} />}>
      {entries.length === 0 ? (
        <Box fontSize="xs">Using latest model versions</Box>
      ) : (
        entries.map((entry) => (
          <Box key={entry.modelLabel} fontSize="xs">
            <Box as="b">{entry.modelLabel}</Box>: {entry.versionLabel}
          </Box>
        ))
      )}
    </SummaryPopover>
  );
};
